import { useState } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { FieldActions, FieldRow, FieldValue } from '@/components/layout/field-row'
import { Button } from '@/components/ui/button'
import { Chip } from '@/components/ui/chip'
import { Flex } from '@/components/ui/flex'
import { TextInput } from '@/components/ui/text-input'
import { Typography } from '@/components/ui/typography'

import { MAX_LOCKERS, OtherFormData } from './other-tab.constants'

export const LuxerLockersEdit = () => {
  const { t } = useTranslation(['organisation'])
  const { setValue } = useFormContext<OtherFormData>()
  const luxerIds = useWatch<OtherFormData, 'luxerIds'>({ name: 'luxerIds' })
  const [value, setInputValue] = useState('')

  const canAdd = /^\d+$/.test(value) && luxerIds.length < MAX_LOCKERS && !luxerIds.includes(value)

  const update = (next: string[]) => setValue('luxerIds', next, { shouldDirty: true })

  const handleAdd = () => {
    if (!canAdd) return
    update([...luxerIds, value])
    setInputValue('')
  }

  return (
    <FieldRow
      hint={t('organisation:places.other.luxer.description', { max: MAX_LOCKERS })}
      label={t('organisation:places.other.luxer.title')}
    >
      <FieldValue>
        <FieldActions>
          <TextInput
            inputMode="numeric"
            name="luxerId"
            placeholder={t('organisation:places.building.luxerIds.placeholder')}
            size="small"
            value={value}
            onChange={(event) => setInputValue(event.target.value.replace(/\D/g, ''))}
            onKeyDown={(event) => {
              if (event.key === 'Enter') {
                event.preventDefault()
                handleAdd()
              }
            }}
          />
          <Button disabled={!canAdd} size="small" onClick={handleAdd}>
            {t('organisation:shared.actions.add')}
          </Button>
        </FieldActions>
        {luxerIds.length ? (
          <Flex gap={8} wrap="wrap">
            {luxerIds.map((id) => (
              <Chip
                key={id}
                color="blue"
                label={id}
                size="small"
                variant="light"
                onRemove={() => update(luxerIds.filter((item) => item !== id))}
              />
            ))}
          </Flex>
        ) : (
          <Typography size="text-small" color="black500">
            {t('organisation:places.other.luxer.empty')}
          </Typography>
        )}
      </FieldValue>
    </FieldRow>
  )
}
